import { Substrate } from './types';
import defaults from './defaults';

export function getCottonSubstrate(): Substrate {
    return {
        ...defaults,
        bumpScale: 1.5,
        bumpTexture: {
            dpi: 30,
            sourceUrl: 'https://vortex.documents.cimpress.io/substrates/natural/v1/bump',
        },
    };
}
